import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SecurityService, User } from "../../_services/security.service";
import { NavigationService } from "../../_services/navigation.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  formError: string;

  constructor(
    private securityService: SecurityService,
    private fb: FormBuilder,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  ngOnInit(): void {

    this.loginForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });

  }

  onSubmit() {
    if (this.loginForm.valid) {

      const credentials = { email: this.loginForm.value.email, password: this.loginForm.value.password };
      
      this.securityService.login(credentials).subscribe((loginRes) => {
        localStorage.setItem("current_user", loginRes.user.email);
        localStorage.setItem("current_user_id", loginRes.user.id);

        const role = this.securityService.mapRole({
          is_admin: loginRes.user.is_admin,
          is_client: loginRes.is_client,
          is_seller: loginRes.is_seller,
        });

        const authenticatedUser: User = {
          username: loginRes.user.email,
          role: role,
        };

        this.securityService.setAuthenticatedUser(authenticatedUser);

       if (role === 'client' || role === 'transporter') {
          this.navigationService.setNavigation('top');
          if (role === 'client') {
            this.router.navigateByUrl("/client");
          } else if (role === 'transporter') {
            this.router.navigateByUrl("/transporteur");
          }
        } else {
          this.navigationService.setNavigation('side');
          this.router.navigateByUrl('/planning').then(() => {
            // Forcer la détection des changements après la navigation
            window.location.reload();
          });
        }
      }, (err) => {
        this.formError = "Email et/ou mot de passe incorrect.";
      });
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/login/login.component.ts